import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { Router } from '@angular/router';
import { TrazabilidadApiService } from 'src/app/service/api/trazabilidad-api.service';
import { Utils } from 'src/app/common/utils';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { BaseView } from '../../base-view';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TrazabilidadModel } from 'src/app/models/stock/trazabilidad.model';
import { TrazabilidadEnvironmentDefinition } from './environment-variables';
import { TrazabilidadFormDefinition } from './trazabilidad-form/form-control/form-definition';
import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import { TreeNode } from 'primeng/api';

@Component({
    selector: 'app-trazabilidad',
    standalone: false,
    templateUrl: './trazabilidad.component.html',
    styleUrls: ['./trazabilidad.component.scss']
})
export class TrazabilidadComponent extends BaseView<TrazabilidadModel> implements OnInit, OnDestroy {

    public env: TrazabilidadEnvironmentDefinition = new TrazabilidadEnvironmentDefinition();

    public form: TrazabilidadFormDefinition | null = null;

    public getRequest: RequestHandler<TrazabilidadModel[]> = this.trazabilidadApi.trazabilidad.GET;

    public deleteRequest: RequestHandler<TrazabilidadModel> = this.trazabilidadApi.trazabilidad.DELETE;

    public pathToForm = 'stock-crear-trazabilidad';

    public menuItemId = 'trazabilidad';

    public btnAnadir = 'Añadir Trazabilidad';

    public override canShow: Record<string, boolean> = {};

    public override model: TrazabilidadModel = {};

    public cols: ColInterface[] = [
        { field: 'cultivo',                 header: 'Cultivo' },
        { field: 'variedad',                header: 'Variedad' },
        { field: 'fecha_recepcion',         header: 'Fecha Recepción' },
        { field: 'semana_entrega_prevista', header: 'Semana Entrega Prevista' },
        { field: 'incidencia',              header: 'Incidencia' },
        { field: 'cantidad',                header: 'Cantidad' },
        { field: 'formato',                 header: 'Formato' },
        { field: 'maceta_reciclada',        header: 'Maceta Reciclada' },
        { field: 'fecha_expedicion',        header: 'Fecha Expedición' },
    ];

    constructor(
        public trazabilidadApi: TrazabilidadApiService,
        private readonly dashboardEvents: DashboardService,
        private readonly router: Router
    ) {
        super(dashboardEvents, trazabilidadApi.trazabilidad.GET);
    }

    ngOnInit(): void {
        this.dashboardEvents.setSubmenuItem('trazabilidad', this.menuItemId);
    }

    public globalConditionalStyle(_value: string, _col: ColInterface): ColStylesInterface {
        return { textAlign: 'center' };
    }

    public globalVisualTransform(value: string, col: ColInterface, _row: TreeNode<TrazabilidadModel>): string {
        if (col.field === 'maceta_reciclada') {
            return value === '1' || (value as any) === 1 ? 'Sí' : 'No';
        }
        return value;
    }

    public add(): void {
        this.router.navigate(['dashboard', this.pathToForm]);
    }

    public edit(data: TrazabilidadModel): void {
        this.router.navigate(['dashboard', 'stock-editar-trazabilidad', data.id]);
    }

    public duplicate(data: TrazabilidadModel): void {
        this.router.navigate(['dashboard', 'stock-duplicar-trazabilidad', data.id]);
    }

    public override show(modal: string, data: TrazabilidadModel): void {
        this.model = data;
        super.show(modal, this.model);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        this.form = new TrazabilidadFormDefinition(formType, data as Record<string, string>, null);
    }

    public override hide(modal: string): void {
        this.model = {};
        this.canShow[modal] = false;
        this.form = null;
    }

    public override ngOnDestroy(): void {
        Utils.unsuscribe([
            this.trazabilidadApi.trazabilidad.GET
        ]);
    }
}